import { render } from "./OngoingExamScreen.vue?vue&type=template&id=2417d486"
import script from "./OngoingExamScreen.vue?vue&type=script&lang=js"
export * from "./OngoingExamScreen.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/dash/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__